import { BiRocket } from 'react-icons/bi';
import { useRecoilState } from 'recoil';
import LoadingIndicator from '../../components/LoadingIndicator';

import Modal from '../../components/modals/Modal';
import { useUpdateQuery, QueryStateV3 } from './QueryBuilderHooksV3';
import { useQueryIdV3 } from './QueryPadStateV3';
import { track } from '../../v2/tracking';

export default function QueryBuilderUnpublishModal({
  openPublish,
  setOpenPublish,
  isV2,
}: {
  openPublish?: boolean;
  setOpenPublish: (v: boolean) => void;
  isV2?: boolean;
}) {
  const queryId = useQueryIdV3();
  const [{ rpcStatus }, { updateQuery }] = useUpdateQuery();
  const [values, setValues] = useRecoilState(QueryStateV3(queryId));

  return (
    <Modal
      open={openPublish}
      onClickBackdrop={() => {
        setOpenPublish(false);
      }}
    >
      <div className='flex flex-col gap-2'>
        <div className='text-xl font-bold'>Remove Query from Community</div>
        <div className='text-sm opacity-70'>
          Unpublishing this query will remove it from the Community hub and
          prevent people from finding and using this query
          <br />
          <br />
        </div>
      </div>
      <div className='flex flex-col gap-3'>
        <div className='flex gap-2 items-center'>
          <button
            className='btn gap-3 btn-error font-bold text-white'
            onClick={async () => {
              const nValues = {
                ...values,
                access: 'private',
              };
              const success = await updateQuery(nValues);
              track('Unpublish Query', {
                queryId,
                fromV2: isV2,
              })

              if (success) {
                setValues(nValues);
                setOpenPublish(false);
              }
            }}
          >
            <BiRocket size='1.1rem' />
            Unpublish
          </button>

          <button
            className='btn btn-ghost'
            style={{ border: '1px solid #aaaaaa' }}
            onClick={() => {
              setOpenPublish(false);
            }}
          >
            Cancel
          </button>
          {rpcStatus.isLoading && <LoadingIndicator />}
        </div>
      </div>
    </Modal>
  );
}
